import { Avatar, Box, Button, CircularProgress } from "@mui/material";
import styles from "./AddNote.module.css";
import React from "react";
import { Mention, MentionsInput } from "react-mentions";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { getCombinedAssignees } from "../../../../../components/CommonFunctions/CommonFunctions";

export default function AddNote(props: any) {
  const {
    CreateNote,
    leadById,
    notePrefilledText,
    handleCancelClick,
    employees,
    fromNotesEdit,
    notesForEditing,
    EditNote,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();

  const { createNoteLoading, editNoteLoading } = useSelector(
    (state: any) => state.nurture
  );

  const combinedEmployees = getCombinedAssignees(employees, leadById?.branchId);

  const activeEmployees = combinedEmployees?.filter((item: any) => {
    const isActiveAndHasLeadCardAccess =
      item.status === "ACTIVE" && item?.leadCardAccess === true;

    return isActiveAndHasLeadCardAccess;
  });

  const [noteDetails, setNoteDetails] = React.useState({
    description: fromNotesEdit ? notesForEditing?.description : "",
    enquiryId: "",
    swimlaneState: "",
    mentionedIds: [],
    createdById: "",
    createdByName: "",
    instituteId: "",
    instituteName: "",
  });

  const handleChange = React.useCallback(
    (event: any) => {
      setNoteDetails({
        ...noteDetails,
        description: event.target.value,
      });
    },
    [noteDetails]
  );

  const handleSaveClick = async (event: any) => {
    event.preventDefault();
    const data = {
      id: notesForEditing?.id,
      enquiryId: leadById.id,
      swimlaneState: leadById.enquirySwimlaneStatus,
      mentionedIds: noteDetails?.mentionedIds,
      updatedById: authUser?.institute?.[0]?.id,
      updatedByName: authUser?.firstName + " " + authUser?.lastName,
      description: noteDetails?.description,
      instituteId: authUser?.institute[0]?.instituteDetails?.id,
      instituteName: authUser?.institute[0]?.instituteDetails?.instituteName,
    };
    try {
      fromNotesEdit ? EditNote(data) : CreateNote(noteDetails);
    } catch (error) {}
  };
  function getNameById(id: any) {
    // Find the employee by ID
    const employee = activeEmployees?.find((e: any) => e.id === id);

    // If found, return the name, else return an empty string or a fallback
    return employee
      ? `${
          employee.firstName.charAt(0).toUpperCase() +
          employee.firstName.slice(1)
        } ${
          employee.lastName.charAt(0).toUpperCase() + employee.lastName.slice(1)
        }`
      : "Unknown";
  }

  const modifiedActiveEmployees = activeEmployees?.map((employee: any) => ({
    id: employee.id,
    display: `${employee.firstName} ${employee.lastName}`,
  }));

  React.useEffect(() => {
    if (leadById) {
      setNoteDetails({
        ...noteDetails,
        enquiryId: leadById.id,
        swimlaneState: leadById.enquirySwimlaneStatus,
        createdById: authUser?.institute?.[0]?.id,
        createdByName: authUser?.firstName + " " + authUser?.lastName,
        instituteId: authUser?.institute[0]?.instituteDetails?.id,
        instituteName: authUser?.institute[0]?.instituteDetails?.instituteName,
      });
    }
  }, [leadById]);

  React.useEffect(() => {
    if (fromNotesEdit) {
      setNoteDetails({
        ...noteDetails,
        mentionedIds: notesForEditing?.mentionedIds,
      });
    }
  }, [notesForEditing, fromNotesEdit]);

  return (
    <div
      style={{
        backgroundColor: "#fff",
        marginBottom: "10px",
        // maxHeight: "calc(98vh - 374px)",
        // minHeight: "calc(98vh - 374px)",
        // overflowY: "auto",
      }}
    >
      <form onSubmit={handleSaveClick}>
        <Box
          sx={{
            color: "#142C44",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "24px",
            padding: "20px 20px 0",
            marginBottom: "6px",
          }}
        >
          Notes
        </Box>
        <div
          style={{
            padding: "0px 20px",
            position: "relative",
          }}
        >
          <MentionsInput
            value={noteDetails.description}
            onChange={handleChange}
            style={{
              control: {
                backgroundColor: "#fff",
                border: "1px solid #E8E8E8",
                fontSize: "14px",
                color: "#69696B",
                height: "auto",
                minHeight: "135px",
                maxHeight: "450px",
                overflow: "auto",
                borderRadius: "4px",
                padding: "10px 10px",
              },
              highlighter: {
                overflow: "hidden",
              },
              input: {
                margin: 0,
                border: "none",
                top: "10px",
                left: "10px",
                bottom: "10px",
                width: "calc(100% - 22px)",
                height: "auto",
                outline: "none",
              },
              "&singleLine": {
                margin: 0,
              },
              suggestions: {
                width: "222px",
                zIndex: 2,
                overflow: "auto",
                maxHeight: "140px",
                backgroundColor: "#fff",
                border: "1px solid #F0F0F0",
                borderRadius: "6px",
                boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.06)",
                fontSize: "14px",
                position: "absolute",
                padding: "10px",
                color: "#142C44",
                fontWeight: "500",
                lineHeight: "16px",
                top:
                  noteDetails.description?.toString()?.split("\n")?.length <= 1
                    ? 0
                    : noteDetails.description?.toString()?.split("\n")
                        ?.length === 2
                    ? "10%"
                    : noteDetails.description?.toString()?.split("\n")
                        ?.length === 3
                    ? "30%"
                    : noteDetails.description?.toString()?.split("\n")
                        ?.length === 4
                    ? "40%"
                    : noteDetails.description?.toString()?.split("\n")
                        ?.length === 5
                    ? "50%"
                    : noteDetails.description?.toString()?.split("\n")
                        ?.length === 6
                    ? "60%"
                    : "100%",
              },
            }}
          >
            <Mention
              data={modifiedActiveEmployees}
              trigger="@"
              markup="@{{__id__}}"
              // markup="@{{firstName}}"
              style={{
                backgroundColor: "#F5F5F7",
                // color: "#667085",
                padding: "5px",
                marginRight: "5px",
                borderRadius: "20px",
              }}
              displayTransform={(id: any, firstName: any) => {
                return "@" + getNameById(id);
              }}
              onAdd={(id: any) => {
                setNoteDetails((prevDetails: any) => {
                  if (!prevDetails?.mentionedIds?.includes(id)) {
                    return {
                      ...prevDetails,
                      mentionedIds: [...prevDetails?.mentionedIds, id],
                    };
                  }
                  return prevDetails;
                });
              }}
              renderSuggestion={(suggestion: any) => (
                <div
                  style={{
                    paddingBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    textTransform: "capitalize",
                  }}
                >
                  <Avatar
                    sx={{
                      width: "34px",
                      height: "34px",
                      fontSize: "16px",
                      alignItems: "center",
                      textTransform: "capitalize",
                      fontWeight: "500",
                      background: "#F5F5F7",
                      border: "1px solid #EEEEF4",
                      color: "#667085",
                    }}
                  >
                    <Box>{suggestion?.display?.charAt(0)}</Box>
                  </Avatar>
                  {suggestion?.display}
                </div>
              )}
            />
          </MentionsInput>
        </div>

        <div className={styles.activityArea}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div className={styles.cancelSave}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCancelClick}
                sx={{
                  textTransform: "capitalize",
                  color: "#9A9EA6",
                  border: "1px solid #E3E3E3",
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                sx={{
                  marginLeft: 1,
                  textTransform: "capitalize",
                }}
                disabled={
                  (!fromNotesEdit && createNoteLoading) ||
                  (fromNotesEdit && editNoteLoading)
                }
              >
                {(!fromNotesEdit && createNoteLoading) ||
                (fromNotesEdit && editNoteLoading) ? (
                  <CircularProgress size={20} color={"inherit"} />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </Box>
        </div>
      </form>
    </div>
  );
}
